import * as React from "react";

const TransferirSaldo = ({ userAttributes }) => {
  return (
    <div className="col-sm-12 col-md-12 col-lg-12 mx-auto">
      <div className="card card-signin">
        <div className="card-body">
          <div className="form-row col-md-12 d-flex justify-content-between">
            <div className="form-group col-md-12 col-xl-12">
              <a
                href={process.env.REACT_APP_PASARELA_PAGO}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-lg btn-primary btn-block text-uppercase "
                style={{ margin: "7px 0px" }}
              >
                Recarga en linea
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransferirSaldo;
